import { JsonServiceClient } from "@servicestack/client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as CreDtos from "../CRE.dtos";

export const siteDataApi = {
    get: () => {
        var client = new JsonServiceClient("");
        var siteDataRequest = new CreDtos.GetSiteData();
        const request = client.get(siteDataRequest);
        return Observable.from(request);
    }
};




// WEBPACK FOOTER //
// ./src/services/siteData.ts